import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { NgxToastrService, PortfolioService } from '@app/_shared/providers';

@Component({
  selector: 'app-failover-warning',
  templateUrl: './failover-warning.component.html',
  styleUrls: ['./failover-warning.component.scss']
})
export class FailoverWarningComponent implements OnInit {
  isSquaredOff : boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { message: String , isSquaredOff?: boolean},
    private dialogRef: MatDialogRef<FailoverWarningComponent>,
  ) { }

  ngOnInit(): void {
    if (this.data.isSquaredOff) {
      this.isSquaredOff = true;
    }
  }
    
  closeDialog(success = false) {
    this.dialogRef.close(success);
  }
  

}